module.exports = "<cat-menu-left></cat-menu-left>\n<cat-top-bar></cat-top-bar>\n<div class=\"cat__content\">\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/app.html
// module id = ../../../../../src/app/app.html
// module chunks = main